import React from 'react'
import ActivateModal from './activate_od_modal'
import { User } from 'react-feather'

import sglogo from '../../../assets/images/study_group_logo.png'
import saologo from '../../../assets/images/sao_logo.png'

import gold from '../../../assets/images/sc-gold.png'
import platinum from '../../../assets/images/sc-platinum.png'
import black from '../../../assets/images/sc-black.png'

import './index.css'
import CopyToClipboard from 'react-copy-to-clipboard'
import handleToast from '../../../components/toaster'

function OdDesactivatedCard({ data, state, setState }) {
  function handleSCImage() {
    let components = {
      Silver: platinum,
      Gold: gold,
      Platinum: platinum,
      Black: black,
      Beginner: platinum,
    }

    return components[data.smile_creator_type]
  }

  return (
    <div className="row mx-auto">
      <div className="col-2 d-flex flex-row justify-content-left ms-2">
        <div
          style={{
            width: '30px',
            height: '30px',
            border: '1px solid #ccc',
            borderRadius: '20px',
            marginTop: '5px',
            marginRight: '5px',
          }}
        >
          {data?.user?.avatar ? (
            <img
              src={data.user.avatar}
              alt="avatar"
              width={28}
              height={28}
              className="od_avatar"
            />
          ) : (
            <User size={25} />
          )}
        </div>
        <CopyToClipboard text={`${data.user?.name} ${data.user?.surname}`}>
          <p
            onClick={() => handleToast('success', '¡Nombre copiado!', 1500)}
            title={`${data.user?.name} ${data.user?.surname}`}
            className="mb-0 text-truncate me-2 hover-bold cursor-pointer"
            style={{ lineHeight: '38px' }}
          >
            {data.user?.name} {data.user?.surname}
          </p>
        </CopyToClipboard>
      </div>
      <div className="col-1 d-flex flex-row justify-content-center">
        <div
          className="mb-0 d-flex flex-row justify-content-center"
          style={{ lineHeight: '38px' }}
        >
          {data.user.groups.length !== 0
            ? data.user.groups.map((group) => (
                <img
                  src={group.id === 1 ? saologo : sglogo}
                  alt={group.name}
                  className="me-1"
                  style={{ width: '45px' }}
                />
              ))
            : 'Sin perfil'}
        </div>
      </div>
      <div className="col-1 d-flex flex-row justify-content-center">
        {data?.smile_creator_type && (
          <img
            src={handleSCImage()}
            style={{ width: '30px', height: '30px', marginTop: '5px' }}
            alt="Smile Creator"
          />
        )}
      </div>
      <div className="col-3 d-flex flex-row justify-content-center">
        <CopyToClipboard text={data.user?.email}>
          <p
            onClick={() => handleToast('success', '¡Email copiado!', 1500)}
            title={data.user?.email}
            className=" mb-0 text-center cursor-pointer text-truncate hover-bold"
            style={{ lineHeight: '38px' }}
          >
            {data.user?.email}
          </p>
        </CopyToClipboard>
      </div>
      <div className="ms-5 col-4 d-flex flex-row justify-content-end">
        <ActivateModal
          state={state}
          setState={setState}
          id={data.id}
          groups={data.user.groups}
          patients={data.patients_count}
          active_treatments={data.treatments_count}
          name={data.user?.full_name}
          sao={data.sao}
        />
      </div>
    </div>
  )
}

export default OdDesactivatedCard
